import {
  RandomKeyObject,
  Flag,
} from '@/modules/Users/store/ClinicConfig/ClinicConfig.types'

export function transformClinicConfig(
  config: Record<string, RandomKeyObject>,
): { [key: string]: RandomKeyObject; flag: Flag } {
  const flag: Flag = {}
  const rest: Record<string, RandomKeyObject> = {}

  Object.entries(config)?.forEach(([key, value]) => {
    if (key?.startsWith('flag')) {
      const flagKey = key?.replace(/^flag/, '')
      if (typeof value === 'boolean') {
        flag[flagKey?.charAt(0)?.toLowerCase() + flagKey?.slice(1)] = value
      } else if (value === null) {
        flag[flagKey?.charAt(0)?.toLowerCase() + flagKey?.slice(1)] = false
      }
    } else {
      rest[key] = value
    }
  })

  return {
    ...rest,
    flag,
  }
}
